import { ValidDate } from '@blk/awt-aladdinwealthserver';
import { getWorkflowDatesApi } from '../../api/AladdinWealthServer';
import { workflowQueryKeys } from './queryKeys';

/**
 * TanStack Query object for workflow dates.
 * Use with useSuspenseQuery or useQuery in components.
 */
export const workflowDatesQuery = {
  queryKey: workflowQueryKeys.dates(),
  queryFn: async (): Promise<ValidDate[]> => {
    const response = await getWorkflowDatesApi();
    return response.data;
  },
};
